
import { useState, useEffect } from 'react';
import { getLessonByDay } from '@/utils/lessonUtils';

export const useLessonCalendar = (initialDay = 1) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(initialDay);
  const [currentLesson, setCurrentLesson] = useState(getLessonByDay(initialDay));
  
  useEffect(() => {
    setCurrentLesson(getLessonByDay(selectedDay));
  }, [selectedDay]);
  
  const handleDateSelect = (date: Date) => {
    setSelectedDate(date);
    // Calculate the day number based on the selected date
    // In a real app, this would map to your lesson content
    const dayDiff = Math.floor((date.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
    const newDay = Math.max(1, dayDiff + initialDay);
    setSelectedDay(newDay);
  };
  
  return {
    selectedDate,
    selectedDay,
    currentLesson,
    handleDateSelect
  };
};
